import * as types from './types';

export const setIsDragging = (isDragging, meta = {}) => ({
  type: types.COMMON_SET_IS_DRAGGING,
  payload: {
    isDragging,
    meta,
  },
});



// WEBPACK FOOTER //
// ./src/state/dragAndDrop/actions.js